import React from 'react';
import { Box, type BoxProps } from '@mui/material';

interface FilterBarContainerProps extends BoxProps {
    children: React.ReactNode;
}

const FilterBarContainer: React.FC<FilterBarContainerProps> = ({ children, sx, ...rest }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 2,
                mb: 1,
                justifyContent: 'center',
                flexWrap: 'wrap',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'center',
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Box>
    );
};

export default FilterBarContainer;
